import Sofia from "../img/trandafiri/1suuny-hills.webp";
import winterSilvaPink from "../img/trandafiri/2winter-silva-pink.webp";
import bloom from "../img/cele-mai-vindute/Bloom.webp";
import splendor from "../img/buchete-premium/6splendor.webp";
import silvaPinkPremium from "../img/buchete-premium/8silva-pink-deluxe.webp";
import morningDelight from "../img/buchete-premium/9morning-delight.webp";
import peonyRadiance from "../img/buchete-premium/10peony-radiance.webp";
import pinkWhisper from "../img/buchete-premium/12pink-whisper.webp";
import hortensiaGrace from "../img/buchete-premium/13hortensia-grace.webp";
import roses101white from "../img/trandafiri/101-white-infinity.webp";
import softPetals from "../img/buchete-premium/16soft-petals.webp";
import roseQuartzCharm from "../img/buchete-premium/18rose-quartz-charm.webp";
import moonlightRose from "../img/buchete-premium/19moonlight-rose.webp";
import velvetParadise from "../img/buchete-premium/20velvet-paradise.webp";
import peonyElegance from "../img/buchete-premium/21peony-elegance.webp";
import roses101red from "../img/trandafiri/101-red-infinity.webp";
// import twilightGlow from "../img/buchete-premium/24twilight-glow.webp";
import morningDew from "../img/buchete-premium/25morning-dew.webp";
import wonder from "../img/buchete-premium/26wonder.webp";
import harmonyFresia from "../img/buchete-premium/27harmony-fresia.webp";
import spicedRose from "../img/buchete-premium/28spiced-rose.webp";
import roseCharm from "../img/buchete-premium/29rose-charm.webp";
import pinkSymphony from "../img/buchete-premium/30pink-symphony.webp";
import mixBliss from "../img/buchete-premium/31mix-bliss.webp";
import gypsofilaDream from "../img/buchete-premium/32gypsophila-dream.webp";
import mintMeadow from "../img/buchete-premium/33mint-meadow.webp";
import duskyBlooms from "../img/buchete-premium/34dusky-blooms.webp";
import loveletter from "../img/new/020loveletter.webp";
import marigold from "../img/new/001marigold.webp";
import hydrangeamelody from "../img/new/015hidrangeamelody.webp";
import charm from "../img/cele-mai-vindute/charm.webp";
import prestige from "../img/buchete/16prestige.webp";
import colordance from "../img/new/013colordance.webp";
import moonlight from "../img/buchete/73moonlight.webp";
import pinksorbet from "../img/new/030pink_sorbet.webp";
import pastelbloom from "../img/new/027pastel_bloom.webp";
import blushTheory from "../img/feb2026/blush_theory.webp";
import petalMuse from "../img/feb2026/petal_muse.webp";

//300-400
const buchetePremium = [
  {
    id: 1507,
    name: "Petal Muse",
    price: "3200 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor, crizanteme, ranuculus si frezie. ",
    images: [petalMuse],
  },
  {
    id: 1503,
    name: "Blush Theory",
    price: "5300 lei",
    description:
      "Cos elegant format din trandafiri de tip bujor, lalele, frezie, ranuculus si eucalipt. ",
    images: [blushTheory],
  },
  // {
  //   id: 335,
  //   name: "Pastel Bloom",
  //   price: "2200 lei",
  //   description:
  //     "Buchet elegant format din hortensii, trandafiri de tip bujori, bujori, eustome si antirinium.",
  //   images: [pastelbloom],
  // },
  // {
  //   id: 334,
  //   name: "Pink Sorbet",
  //   price: "6000 lei",
  //   description:
  //     "Buchet elegant format din hortensii, trandafiri Silva Pink, trandafiri Avalanche.",
  //   images: [pinksorbet],
  // },
  {
    id: 301,
    name: "Winter Silva Pink",
    price: "4000 lei",
    description:
      "Buchet de amrime XL format din trandafiri de tip bujor Silva Pink si eucalipt.",
    images: [winterSilvaPink],
  },
  {
    id: 302,
    name: "Love Letter",
    price: "6600 lei",
    description: "Buchet grandios format din 19 hortensii. ",
    images: [loveletter],
    // checkAvailability: true,
  },
  {
    id: 303,
    name: "Splendor",
    price: "3400 lei",
    description:
      "Buchet rafinat format din hortensii, trandafiri Silva Pink si eucalipt.",
    images: [splendor],
  },
  {
    id: 304,
    name: "Hydrangea Melody",
    price: "3000 lei",
    description:
      "Buchet spectaculos format din 7 hortensii si mix de trandafiri. ",
    images: [hydrangeamelody],
  },
  {
    id: 305,
    name: "Sofia",
    price: "1800 lei",
    description:
      "Buchet elegant format din trandafiri crenguta de soi Sofia, eustome albe si eucalipt..",
    images: [Sofia],
    // checkAvailability: true,
  },
  {
    id: 306,
    name: "Silva Pink Premium",
    price: "4600 lei",
    description:
      "Buchet rafinat format din trandafiri Silva Pink si eucalipt. ",
    images: [silvaPinkPremium],
  },
  // {
  //   id: 309,
  //   name: "Peony Radiance",
  //   price: "2500 lei",
  //   description:
  //     "Buchet rafinat format din hortensii, trandafiri Avalanche, bujori, astromerii si gipsofila.",
  //   images: [peonyRadiance],
  //   // checkAvailability: true,
  // },
  {
    id: 310,
    name: "Pink Whisper",
    price: "2500 lei",
    description:
      "Buchet rafinat format din hortensii, trandafiri de tip bujor si eustome.",
    images: [pinkWhisper],
  },
  {
    id: 311,
    name: "Hortensia Grace",
    price: "3000 lei",
    description:
      "Buchet catifelat format din hortensii, trandafiri Sofia, bujori si matiole.",
    images: [hortensiaGrace],
    // checkAvailability: true,
  },
  {
    id: 312,
    name: "101 White Infinity",
    price: "8500 lei",
    description:
      "Buchet extravagant de marime XXL format din 101 trandafiri albi.",
    images: [roses101white],
    // checkAvailability: true,
  },
  {
    id: 313,
    name: "Soft Petals",
    price: "2100 lei",
    description:
      "Buchet catifelat format din hortensii, trandafiri Silva Pink, eustome si eucalipt.",
    images: [softPetals],
  },
  // {
  //   id: 314,
  //   name: "Rose Quartz Charm",
  //   price: "2400 lei",
  //   description:
  //     "Buchet delicat format din hortensii, trandafiri de tip bujor, trandafiri crenguta, eustome, dianthus si eucalipt.",
  //   images: [roseQuartzCharm],
  // },
  // {
  //   id: 315,
  //   name: "Moonlight Rose",
  //   price: "3000 lei",
  //   description:
  //     "Buchet sofisticat format din 5 hortensii, trandafiri Silva Pink, si eucalipt.",
  //   images: [moonlightRose],
  //   // checkAvailability: true,
  // },
  {
    id: 316,
    name: "Bloom",
    price: "2200 lei",
    description:
      "Buchet superb format din trandafiri de tip Bujor, lalele și eucalipt.",
    images: [bloom],
    // checkAvailability: true,
  },
  {
    id: 317,
    name: "Velvet Paradise",
    price: "2750 lei",
    description:
      "Buchet elegant format din hortensii, trandafiri Avalanche, trandafiri de tip bujor, eustome roz si eucalipt.",
    images: [velvetParadise],
  },
  {
    id: 318,
    name: "Peony Elegance",
    price: "4700 lei",
    description:
      "Buchet sofisticat format din bujori de soi Sarah Bernardth si gipsofila colorata.",
    images: [peonyElegance],
    // checkAvailability: true,
  },
  {
    id: 319,
    name: "101 Red Infinity",
    price: "8000 lei",
    description:
      "Buchet extravagant de marime XXL format din 101 trandafiri rosii.",
    images: [roses101red],
    // checkAvailability: true,
  },
  {
    id: 320,
    name: "Morning Dew",
    price: "2000 lei",
    description:
      "Buchet romantic format din hortensie, trandafiri Avalanche, trandafiri de tip bujor, eustome, antirrhinum si eucalipt.",
    images: [morningDew],
  },
  {
    id: 321,
    name: "Wonder",
    price: "1800 lei",
    description: "Buchet delicat format din hortensii si gipsofila alba.",
    images: [wonder],
  },
  {
    id: 323,
    name: "Spiced Rose",
    price: "3400 lei",
    description:
      "Buchet rafinat format din trandafiri Silva Pink, eustome albe si gipsofila alba.",
    images: [spicedRose],
  },
  {
    id: 324,
    name: "Rose Charm",
    price: "1900 lei",
    description:
      "Buchet rafinat format din hortensii, trandafiri Silva Pink si eucalipt.",
    images: [roseCharm],
  },
  {
    id: 325,
    name: "Charm",
    price: "2300 lei",
    description:
      "Compoziție superbă din gipsofila albă si trandafiri de tip Bujor.",
    images: [charm],
  },
  {
    id: 326,
    name: "Pink Symphony",
    price: "3500 lei",
    description:
      "Buchet spectaculos format din hortensii, trandafiri Silva Pink, trandafiri Avalanche, orhidei, matiole si gipsofila color.",
    images: [pinkSymphony],
  },
  {
    id: 328,
    name: "Color Dance",
    price: "2200 lei",
    description:
      "Buchet format din hortensie, bujori, trandafiri de tip bujor, frezie, trandafiri memory si eucalipt.",
    images: [colordance],
    // checkAvailability: true,
  },
  {
    id: 330,
    name: "Gypsofila Dream",
    price: "1900 lei",
    description: "Buchet XL format din gipsofila colorata.",
    images: [gypsofilaDream],
  },
  {
    id: 331,
    name: "Mint Meadow",
    price: "3000 lei",
    description:
      "Buchet grandios format din hortensii, trandafiri Silva Pink, eustome albe si eucalipt.",
    images: [mintMeadow],
  },
];

export default buchetePremium;
